
export default function Reviews() {
  const reviews = [
    {
      name: '大学生 Kさん',
      age: '21歳',
      rating: 5,
      comment:
        '22歳以下なら年会費無料なのが最高！ドコモユーザーなので毎月のスマホ代でもポイントが貯まって、空港ラウンジも使えるのでコスパ抜群です。',
      highlight: '年会費実質無料',
    },
    {
      name: '会社員 Tさん',
      age: '26歳',
      rating: 5,
      comment:
        'ahamoを使っているので毎月+5GBがありがたい。ポイ活MAXで11%還元も魅力的。30歳までにしっかり使い倒します！',
      highlight: 'ahamo+5GB',
    },
    {
      name: '新社会人 Mさん',
      age: '23歳',
      rating: 4,
      comment:
        'ゴールドカードなのに年間30万円使えば年会費無料。月2.5万円なら普通に達成できるので、実質無料でゴールドカードが持てます。',
      highlight: '条件達成で無料',
    },
    {
      name: 'フリーランス Sさん',
      age: '28歳',
      rating: 4,
      comment:
        'ケータイ補償が3年間10万円まであるのが安心。スマホを落としやすいので、この補償だけでも年会費の元が取れます。',
      highlight: 'ケータイ補償充実',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-[#003366] mb-4">
          利用者の口コミ・評判
        </h2>
        <p className="text-center text-gray-600 mb-12">
          実際にdカード GOLD Uを使っている方の声
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-all"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-[#E60033] rounded-full flex items-center justify-center">
                    <i className="ri-user-line text-xl text-white"></i>
                  </div>
                  <div>
                    <p className="font-bold text-[#003366]">{review.name}</p>
                    <p className="text-sm text-gray-500">{review.age}</p>
                  </div>
                </div>
                <span className="bg-[#E60033] text-white text-xs px-3 py-1 rounded-full font-bold whitespace-nowrap">
                  {review.highlight}
                </span>
              </div>

              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, i) => (
                  <i
                    key={i}
                    className={`ri-star-fill text-lg ${
                      i < review.rating ? 'text-[#FFD700]' : 'text-gray-300'
                    }`}
                  ></i>
                ))}
              </div>

              <p className="text-sm text-gray-700 leading-relaxed">{review.comment}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
